<template>
  <div class="contry-wrapper">
    <img
      class="country"
      :src="model.searchImg"
      alt=""
    >
    <div class="input-wrapper">
      <input
        @focus="onCountryInputFocus"
        @blur="onCountryInputBlur"
        @input="onCountryInput"
        class="input"
        v-model="model.country"
        type="text"
      >
      <div
        v-if="showCountryHint"
        class="hint"
      >
        {{ lastCountry }}
      </div>
    </div>
    <Icon
      class="icon"
      :class="{
        'icon-search': showCountryScrolldown
      }"
      :name="showCountryScrolldown ? 'search-l' : 'arrow-down-l-2'"
    />
    <!-- 下拉框 -->
    <div
      v-if="showCountryScrolldown"
      class="scroll-down-list"
    >
      <div
        @mousedown="onSelectCountry(item)"
        v-for="(item, index) in scrollList"
        :key="index"
        class="scroll-down-list-item"
      >
        <img
          class="image"
          :src="item?.countryUrl"
          alt=""
        >
        <div class="text">
          {{ `${ item.countryName }` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Icon } from '@/components/Icon'

const props = defineProps({
  model: {
    type: Object,
    default: () => ({})
  },
  countryList: {
    type: Array,
    default: () => []
  }
})

const showCountryScrolldown = ref(false)

const showCountryHint = ref(false)

const lastCountry = ref('')

const scrollList = ref(props.countryList)

const onCountryInputFocus = () => {
  scrollList.value = props.countryList

  lastCountry.value = props.model.country
  props.model.country = ''

  showCountryHint.value = true
  showCountryScrolldown.value = true
}

const onCountryInputBlur = () => {
  if (lastCountry.value) {
    props.model.country = lastCountry.value
  }
  lastCountry.value = ''

  showCountryHint.value = false
  showCountryScrolldown.value = false
}

const onSelectCountry = (item) => {
  lastCountry.value = ''
  props.model.countryCode = item.countryCode
  props.model.searchImg = item.countryUrl
  props.model.country = item.countryName
  showCountryHint.value = false
}

const onCountryInput = (e) => {
  showCountryHint.value = false
  const val = String(e.target.value).toLowerCase()
  scrollList.value = props.countryList.filter(item => {
    const countryName = String(item.countryName).toLowerCase()
    return countryName.includes(val)
  })
}
</script>

<style lang='less' scoped>
.contry-wrapper {
  position: relative;

  .country, .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9;
  }
  .icon-search {
    font-size: 20px;
  }
  .country {
    left: 8px;
    width: 20px;
    object-fit: contain;
  }
  .icon {
    right: 8px;
  }
  .input-wrapper {
    position: relative;
    .hint {
      position: absolute;
      top: 50%;
      left: 36px;
      transform: translateY(-50%);
      color: #b2b7c2;
      font-size: 12px;
      font-family: mon-500;
    }
    .input {
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      border: none;
      outline: none;
      width: 100%;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #ebf1f5;
      padding: 0 16px 0 36px;
      &::placeholder {
        color: #b2b7c2;
        font-size: 12px;
        font-family: mon-500;
      }

      &:focus {
        border: 2px solid #232323;
      }
    }
  }

  .scroll-down-list {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    height: 186px;
    overflow: scroll;
    padding: 8px 4px;
    border: 1px solid #ebf1f5;
    border-radius: 4px;
    background-color: white;
    .scroll-down-list-item {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 34px;
      border-radius: 2px;
      padding: 0 12px;
      &:hover {
        background-color: #f8f8f8;
        cursor: pointer;
      }
      .image {
        width: 16px;
        object-fit: contain;
      }
      .text {
        color: #232323;
        font-size: 11px;
        font-family: mon-500;
      }
    }
  }
}
</style>
